import { Button } from "react-bootstrap";

function CreateButton({ handler, disabled }) {
  return (
    <Button
      disabled={disabled}
      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
      type="submit"
      onClick={handler}
    >
      {disabled ? (
        <div>
          <i className="fa fa-circle-notch fa-spin"></i>{" "}
          <span>Please Wait...</span>
        </div>
      ) : (
        <div>
          <i className="fa fa-check" />{" "}
          <span>Create</span>
        </div>
      )}
    </Button>
  );
}

export default CreateButton;
